// Core
import { 
  Route, 
  Switch, 
  Redirect, 
  useRouteMatch, 
} from 'react-router-dom';

// Chakra imports
import { 
  Box,
} from '@chakra-ui/react';

// Components
import PosTransaction from './PosTransaction';
import PosTransactionDetails from './PosTransactionDetails';

function PosTransactions(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Box>
        <Switch>
          <Route path={`${path}/:id`} render={() => <PosTransactionDetails/>}/>
          <Route path={`${path}`} render={() => <PosTransaction/>}/>
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default PosTransactions;